import React from 'react'
import { Navigate } from 'react-router'

const ProtectedRoute = ({element, nopromo, routeUrl}) => {
  const user = localStorage.getItem("user_obj");
  const channel = localStorage.getItem('channel');
  const baseRoute = nopromo && routeUrl ? routeUrl : `/${channel === 'alopexia-ads' ? 'c1' : 'start-test'}`;

  return (
    user ? element : <Navigate to={baseRoute} replace/>
  )
}

export default ProtectedRoute